const getters = {
  token: state => state.user.token,
  survey_token: state => state.user.survey_token,
  list_url: state => state.list.list_url,
  detail_url: state => state.list.detail_url
}
export default getters
